import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

const KURS_REIHENFOLGE = ['pirat', 'seepferdchen', 'trixi', 'bronze', 'silber', 'gold'];

const KURS_INFO = {
  pirat:          { label: 'Pirat',            farbe: '#880e4f', bg: '#fce4ec', emoji: '🏴‍☠️' },
  seepferdchen:   { label: 'Seepferdchen',     farbe: '#0d47a1', bg: '#e3f2fd', emoji: '🐴' },
  trixi:          { label: 'Trixi',            farbe: '#1b5e20', bg: '#e8f5e9', emoji: '🌟' },
  bronze:         { label: 'Bronze',           farbe: '#e65100', bg: '#fff3e0', emoji: '🥉' },
  silber:         { label: 'Silber',           farbe: '#424242', bg: '#f5f5f5', emoji: '🥈' },
  gold:           { label: 'Gold',             farbe: '#f57f17', bg: '#fffde7', emoji: '🥇' },
};

export default function Gruppen() {
  const navigate = useNavigate();
  const [gruppen, setGruppen] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    api.get('/api/admin/gruppen')
      .then(r => setGruppen(r.data))
      .catch(() => setError('Gruppen konnten nicht geladen werden'))
      .finally(() => setLoading(false));
  }, []);

  // Gruppiert nach Kurs-Typ
  const gruppiertNachTyp = KURS_REIHENFOLGE.map(typ => ({
    typ,
    gruppen: gruppen.filter(g => g.kurs_typ === typ),
  })).filter(s => s.gruppen.length > 0);

  return (
    <div>
      <div className="page-header">
        <h2 className="page-title">Ausbildungsgruppen</h2>
        <button className="btn btn-primary btn-sm" onClick={() => navigate('/gruppen/neu')}>
          + Neue Gruppe
        </button>
      </div>

      {error && <div className="alert alert-error">{error}</div>}

      {loading ? (
        <div style={{ textAlign: 'center', padding: '2rem' }}><div className="loading-spinner" style={{ margin: '0 auto' }} /></div>
      ) : gruppen.length === 0 ? (
        <div className="empty-state">
          <div className="empty-state-icon">🏊</div>
          <div className="empty-state-text">Noch keine Ausbildungsgruppen angelegt</div>
          <button className="btn btn-primary btn-sm" style={{ marginTop: '1rem' }} onClick={() => navigate('/gruppen/neu')}>
            Erste Gruppe anlegen
          </button>
        </div>
      ) : (
        gruppiertNachTyp.map(({ typ, gruppen: gs }) => {
          const info = KURS_INFO[typ];
          return (
            <div key={typ} style={{ marginBottom: '2rem' }}>
              <div style={{
                display: 'flex', alignItems: 'center', gap: '0.5rem',
                marginBottom: '0.75rem', paddingBottom: '0.5rem',
                borderBottom: `2px solid ${info.farbe}`,
              }}>
                <span style={{ fontSize: '1.25rem' }}>{info.emoji}</span>
                <h3 style={{ margin: 0, color: info.farbe, fontSize: '1.1rem' }}>{info.label}</h3>
                <span style={{ color: 'var(--text-muted)', fontSize: '0.85rem', marginLeft: '0.25rem' }}>
                  ({gs.length} {gs.length === 1 ? 'Gruppe' : 'Gruppen'})
                </span>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: '0.875rem' }}>
                {gs.map(g => {
                  const auslastung = g.max_teilnehmer > 0
                    ? Math.round((parseInt(g.aktive_mitglieder) / g.max_teilnehmer) * 100)
                    : 0;
                  const voll = parseInt(g.aktive_mitglieder) >= g.max_teilnehmer;

                  return (
                    <div key={g.id} className="card"
                      style={{ cursor: 'pointer', borderLeft: `4px solid ${info.farbe}`, padding: '1rem' }}
                      onClick={() => navigate(`/gruppen/${g.id}`)}>

                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '0.5rem' }}>
                        <div style={{ fontWeight: 700, fontSize: '1rem', color: 'var(--primary)' }}>{g.name}</div>
                        <span style={{
                          padding: '2px 8px', borderRadius: 10, fontSize: '0.72rem', fontWeight: 700,
                          background: g.aktiv ? '#e8f5e9' : '#f5f5f5',
                          color: g.aktiv ? '#2e7d32' : '#616161',
                        }}>{g.aktiv ? 'Aktiv' : 'Inaktiv'}</span>
                      </div>

                      {g.trainer && <div style={{ fontSize: '0.8rem', color: 'var(--text-muted)', marginBottom: '0.25rem' }}>👤 {g.trainer}</div>}
                      {g.ort && <div style={{ fontSize: '0.8rem', color: 'var(--text-muted)', marginBottom: '0.25rem' }}>📍 {g.ort}</div>}
                      {(g.wochentag || g.uhrzeit) && (
                        <div style={{ fontSize: '0.8rem', color: 'var(--text-muted)', marginBottom: '0.75rem' }}>
                          🕐 {[g.wochentag, g.uhrzeit].filter(Boolean).join(', ')}
                        </div>
                      )}

                      {/* Auslastungs-Balken */}
                      <div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.78rem', marginBottom: '0.25rem' }}>
                          <span style={{ color: voll ? '#c62828' : 'var(--text-muted)' }}>
                            {voll ? '⚠ Voll' : `${g.aktive_mitglieder} Mitglieder`}
                          </span>
                          <span style={{ color: 'var(--text-muted)' }}>max. {g.max_teilnehmer}</span>
                        </div>
                        <div style={{ background: '#e0e0e0', borderRadius: 4, height: 6 }}>
                          <div style={{
                            width: `${Math.min(auslastung, 100)}%`, height: '100%', borderRadius: 4,
                            background: auslastung >= 100 ? '#c62828' : auslastung >= 80 ? '#f57c00' : info.farbe,
                            transition: 'width .3s',
                          }} />
                        </div>
                      </div>
                    </div>
                  );
                })}

                {/* Neue Gruppe dieser Stufe */}
                <div className="card"
                  style={{ cursor: 'pointer', borderLeft: `4px dashed ${info.farbe}`, padding: '1rem',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    color: info.farbe, opacity: 0.7, minHeight: 100 }}
                  onClick={() => navigate(`/gruppen/neu?typ=${typ}`)}>
                  + {info.label}-Gruppe hinzufügen
                </div>
              </div>
            </div>
          );
        })
      )}

      {/* Leere Stufen als Hinweis */}
      {!loading && KURS_REIHENFOLGE.filter(typ => !gruppiertNachTyp.find(g => g.typ === typ)).map(typ => {
        const info = KURS_INFO[typ];
        return (
          <div key={typ} style={{ marginBottom: '1rem' }}>
            <button
              onClick={() => navigate(`/gruppen/neu?typ=${typ}`)}
              style={{
                display: 'flex', alignItems: 'center', gap: '0.5rem',
                background: 'none', border: `1px dashed ${info.farbe}`, borderRadius: 8,
                padding: '0.5rem 1rem', cursor: 'pointer', color: info.farbe, opacity: 0.6,
                fontSize: '0.85rem',
              }}>
              {info.emoji} {info.label} – Erste Gruppe anlegen
            </button>
          </div>
        );
      })}
    </div>
  );
}
